export const busStationsDefaultPrePopulation = {
  siteEdition: 'en-us',
  languageCode: 'en',
  markets: ['ca'],
  origin: null,
  destination: null,
  minSearchLength: 4,
  maxSearchLength: 50,
  locationSearchOptions: {
    distance: 50,
    outputCategory: ['STATIONS', 'CITIES', 'STATES'],
    sorting: 'ASC',
    itemsPerCategory: 3,
  },
  busSearchOptions: {
    outputFields: ['extraInfo', 'state', 'iataCode'],
    geoField: {
      name: 'geo',
      value: 50,
    },
    sortingDetails: [
      {
        field: 'name',
        order: 'ASC',
      },
    ],
    filterFields: [
      {
        name: 'active',
        values: ['true'],
      },
    ],
    setting: {
      airportSource: 'TRFX',
      routeSource: 'TRFX',
    },
  },
  departure: {
    start: 0,
    end: 7,
  },
  return: {
    start: 14,
    end: 21,
  },
};
